import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from 'components/lib/error_message';

const SelectHeader = props => {
  const errorMessage = renderErrorMessage({
    errorString: props.errorString,
    errorClasses: props.errorClasses,
    selectedCount: props.selectedCount,
  });

  const clearSelected = renderClearSelected({
    selectedCount: props.selectedCount,
    onClearSelected: props.onClearSelected,
  });

  return (
    <div className="selectHeader">
      <div className="selectHeader-left-container">
        <div className="selectHeader-title">{props.title}</div>
        {errorMessage}
      </div>

      <div className="selectHeader-right-container">
        {clearSelected}
        <div className="selectHeader-currentCount">{`${props.selectedCount} selected`}</div>
      </div>
    </div>
  );
};

function renderClearSelected({ selectedCount, onClearSelected }) {
  if (selectedCount <= 0) {
    return null;
  }

  return (
    <div className="selectHeader-clearSelected" onClick={onClearSelected}>
      clear selected
    </div>
  );
}

function renderErrorMessage({ errorString, selectedCount, errorClasses }) {
  if (!errorString) {
    return null;
  }

  return <ErrorMessage message={errorString} errorClasses={errorClasses} />;
}

SelectHeader.propTypes = {
  title: PropTypes.string.isRequired,
  selectedCount: PropTypes.number.isRequired,
  onClearSelected: PropTypes.func.isRequired,
  errorString: PropTypes.string,
};

export default SelectHeader;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/lib/select_header.jsx